import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly TOKEN_KEY = 'auth_token';
  isLoggedIn = new BehaviorSubject<boolean>(this.checkIsLoggedIn());

  setToken(token: string): void {
    localStorage.setItem(this.TOKEN_KEY, token);
    this.isLoggedIn.next(true);
  }

  getToken(): string | null {
    return localStorage.getItem(this.TOKEN_KEY);
  }

  clearToken(): void {
    localStorage.clear();
    this.isLoggedIn.next(false);
  }

  checkIsLoggedIn(): boolean {
    return !!this.getToken();
  }
}
